import { FETCH_USERS_RIGHTS_AND_ROLES, SET_USERS_RIGHTS_AND_ROLES } from "../types"

export function fetchUserRightsAndRoles() {
  return { type: FETCH_USERS_RIGHTS_AND_ROLES }
}

export function setUserRightsAndRoles(data) {
  return { type: SET_USERS_RIGHTS_AND_ROLES, data }
}
